import {
  CBadge,
  CCol,
  CForm,
  CFormFeedback,
  CFormLabel,
  CFormSelect,
  CLoadingButton,
  CMultiSelect,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import Bootbox from 'bootbox-react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import BracketBattleService from 'src/service/BracketBattleService'
import ToastComponent from 'src/components/common/TaostComponent'

const BracketRound = () => {
  const [selectedValue, setSelectedValue] = useState([])
  const [multiSelectKey, setMultiSelectKey] = useState(0)
  const [roundSelectKey, setRoundSelectKey] = useState(0)

  const [users, setUsers] = useState([])
  const [roundListing, setRoundListing] = useState([])
  const [gwData, setGwData] = useState([])
  const [bracketDetails, setbracketDetails] = useState({})
  const validationSchema = Yup.object().shape({
    round: Yup.string().required('Please select Round.'),
    gw_round: Yup.array().required('GW Round is required'),
  })
  const [loader, setLoader] = useState(false)
  const formik = useFormik({
    initialValues: {
      round: '',
      gw_round: '',
      structure: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, { resetForm }) => {
      data.gameweeks = selectedValue
      data.structure = bracketDetails.structure
      setLoader(true)
      BracketBattleService.saveBracketRound(data)
        .then((res) => {
          if (res.status === 200) {
            setSelectedValue([])
            setGwData(res.gw_data)
            setRoundListing(res.round_list)
            setUsers(res.data)
            ToastComponent(res.message, 'success')
            resetForm({
              // Reset the form fields
              round: '',
              gw_round: '',
              structure: '',
            })
            setLoader(false)
            setMultiSelectKey((prevKey) => prevKey + 1)
            setRoundSelectKey((prevKey) => prevKey + 1)
            fetchData()
          }
        })
        .catch((e) => {
          console.log('Here is Error', e)
          ToastComponent('Something Went wront. Please try again.', 'error')
        })
    },
  })

  const fetchData = () => {
    BracketBattleService.listing().then((result) => {
      setUsers(result.data)
      setRoundListing(result.round_list)
      setGwData(result.gw_data)
      setbracketDetails(result.bracket_details)
    })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const getBadge = (status) => {
    switch (status) {
      case 1:
        return 'warning'
      case 2:
        return 'success'
      default:
        return 'danger'
    }
  }

  const handleMultoOptionChange = (e) => {
    const selectedValues = Array.isArray(e) ? e.map((x) => x.value) : []
    // Set the gw_round field directly in Formik
    formik.setFieldValue('gw_round', selectedValues)
    setSelectedValue(selectedValues)
  }

  const [showConfirm, setShowConfirm] = useState(false)
  const [recordId, setRecordId] = useState(false)
  const handleConfirm = () => {
    handleDeleteBracketRound()
    return setShowConfirm(false)
  }
  const showCofirmBox = (recordId, status) => {
    setRecordId(recordId)
    setShowConfirm(true)
  }

  const handleCancel = () => {
    console.log('You clicked No!')
    return setShowConfirm(false)
  }
  const handleDeleteBracketRound = () => {
    const data = {}
    data.id = recordId
    BracketBattleService.deleteBracketRound(data).then((result) => {
      ToastComponent(result.message, 'success')
      fetchData()
    })
  }

  return (
    <>
      <CAccordion activeItemKey={1} alwaysOpen>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            {' '}
            <strong>Create Bracket Round</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <CForm className="row g-3" onSubmit={formik.handleSubmit}>
              <CCol md={6}>
                <CFormLabel className="fw-bold" htmlFor="round">
                  Select Round
                </CFormLabel>

                <CFormSelect
                  key={roundSelectKey}
                  aria-label="select round"
                  name="round"
                  className={
                    'form-control' +
                    (formik.errors.round && formik.touched.round ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.round}
                  onChange={formik.handleChange}
                  id="round"
                >
                  <option value={0}>Select Round</option>
                  {roundListing &&
                    roundListing.map((item, key) => (
                      <option value={item?.id} key={key}>
                        {item?.name}
                      </option>
                    ))}
                </CFormSelect>
                {formik.errors.round && formik.touched.round && (
                  <CFormFeedback invalid>{formik.errors.round}</CFormFeedback>
                )}
              </CCol>
              <CCol md={6}>
                <CFormLabel className="fw-bold" htmlFor="grade">
                  Select Gameweeks For The Round*
                </CFormLabel>
                <CMultiSelect
                  key={multiSelectKey}
                  options={gwData || []}
                  selectionType="tags"
                  name="gw_round"
                  className={formik.errors.gw_round && formik.touched.gw_round ? 'is-invalid' : ''}
                  onChange={handleMultoOptionChange}
                  value={selectedValue}
                  popper={false}
                />
                {formik.errors.gw_round && formik.touched.gw_round && (
                  <CFormFeedback invalid>{formik.errors.gw_round}</CFormFeedback>
                )}
              </CCol>
              <CCol md={6}>
                <CLoadingButton
                  type="submit"
                  color="success"
                  variant="outline"
                  loading={loader}
                  id="submit"
                >
                  Submit
                </CLoadingButton>
              </CCol>
            </CForm>
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      <CAccordion activeItemKey={1}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            {' '}
            <strong>Manage Bracket Rounds</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <table className="main-table table innertable">
              <thead>
                <tr>
                  <th>Rounds </th>
                  <th>Fantasy Rounds</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {users &&
                  users.map((item, key) => (
                    <tr key={key}>
                      <th>{item.round}</th>
                      <td>{item?.rd}</td>
                      <td>
                        <CBadge color={getBadge(item.status)}>
                          {item.status === 1
                            ? 'In-Process'
                            : item.status === 2
                            ? 'Completed'
                            : 'Not started Yet'}
                        </CBadge>
                      </td>
                      <td>
                        <Link
                          size="sm"
                          className="btn btn-success btn-sm ms-1"
                          to={`/bracket-battle/battle-listing/${item.id}`}
                        >
                          Create Round Battles
                        </Link>
                        <Link
                          size="sm"
                          className="btn btn-info btn-sm ms-1"
                          to={`/bracket-battle/match-result/${item.id}`}
                        >
                          Results
                        </Link>

                        {item?.status !== 2 && (
                          <Link
                            size="sm"
                            className="btn btn-danger btn-sm ms-1"
                            onClick={() => showCofirmBox(item?.id)}
                          >
                            Delete
                          </Link>
                        )}

                        {/* <CButton
                      className="mx-2"
                      color="success"
                      onClick={() => openFromParentForPlayer(item.team_power_id, item.round)}
                    >
                      Points
                    </CButton> */}
                      </td>
                    </tr>
                  ))}
                {users.length === 0 && (
                  <tr>
                    <td colSpan={4}>No record yet available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      <Bootbox
        show={showConfirm}
        type={'confirm'}
        message={
          'Deleting this Round will delete this Round and any subsequent existing Rounds. Are you sure you want to delete?'
        }
        onSuccess={handleConfirm}
        onCancel={handleCancel}
        onClose={handleCancel}
      />
    </>
  )
}

export default BracketRound
